import React, { useState } from "react";
import "./ContactAdminBox.css";
import { db, auth } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function ContactAdminBox() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [honeypot, setHoneypot] = useState(""); // Bot trap field
  const [submitTime, setSubmitTime] = useState(null);

  // Set timestamp when form opens
React.useEffect(() => {
  if (isOpen && !submitTime) {
    setSubmitTime(Date.now());
  }
}, [isOpen, submitTime]); // Add submitTime to deps

  async function handleSubmit(e) {
    e.preventDefault();
    
    // Bot checks
    if (honeypot) {
      // If honeypot field is filled, it's a bot
      console.log("Bot detected: honeypot field filled");
      return;
    }

    const timeTaken = Date.now() - submitTime;
    if (timeTaken < 3000) {
      // If form submitted in less than 3 seconds, likely a bot
      setError("Please take a moment to review your message");
      return;
    }

    if (!message.trim()) {
      setError("Please enter a message, Include an email address for reply");
      return;
    }

    setSending(true);
    setError("");

    try {
      const user = auth.currentUser;
      
      await addDoc(collection(db, "supportMessages"), {
        userId: user?.uid || "anonymous",
        email: user?.email || "not provided",
        message: message.trim(),
        type: "verification-issue",
        status: "pending",
        createdAt: serverTimestamp(),
        verified: true
      });

      setSent(true);
      setMessage("");
      
      setTimeout(() => {
        setIsOpen(false);
        setSent(false);
      }, 3000);
    } catch (err) {
      console.error("Error sending message:", err);
      setError("Failed to send message. Please try again.");
    } finally {
      setSending(false);
    }
  }

  if (!isOpen) {
    return (
      <div className="contact-admin-trigger">
        <button 
          className="no-email-link"
          onClick={() => setIsOpen(true)}
        >
          I'm having an issue! Help!
        </button>
      </div>
    );
  }

  return (
    <div className="contact-admin-box">
      <div className="contact-header">
        <h3>Contact Admin</h3>
        <button 
          className="close-btn"
          onClick={() => setIsOpen(false)}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      {sent ? (
        <div className="success-message">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2"/>
            <path d="M8 12l2 2 4-4" stroke="#10b981" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <p>Message sent! An admin will help you shortly.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <p className="contact-description">
            Describe your issue and we'll try and help, Include a reply email address.
          </p>
          
          {/* Honeypot field - hidden from real users, bots will fill it */}
          <input
            type="text"
            name="website"
            className="honeypot-field"
            value={honeypot}
            onChange={(e) => setHoneypot(e.target.value)}
            tabIndex="-1"
            autoComplete="off"
            aria-hidden="true"
          />
          
          <textarea
            className="contact-textarea"
            placeholder="Example: I registered 30 minutes ago but haven't received a verification email. My email is correct and I checked spam."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            disabled={sending}
          />

          {error && <p className="error-text">{error}</p>}

          <div className="contact-actions">
            <button
              type="button"
              className="btn-cancel"
              onClick={() => setIsOpen(false)}
              disabled={sending}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-submit"
              disabled={sending}
            >
              {sending ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}